const finite = (value, fallback = 0) => (
  Number.isFinite(Number(value)) ? Number(value) : fallback
);

/**
 * Decide how much of a real-time gap is safe to simulate in the client.
 *
 * A normal background Worker tick is a few hundred milliseconds. A large gap
 * usually means the OS/browser suspended the page; replaying it as a burst
 * produces duplicate-looking rewards, modal storms and an optimistic save that
 * can race the authoritative sync. Rebase the clock instead and let resume
 * reconciliation pull the server state.
 */
export function simulationWindow(
  elapsedSeconds,
  { maxCatchupSeconds = 30, resumeGapSeconds = 5 } = {},
) {
  const elapsed = Math.max(0, finite(elapsedSeconds));
  const maxCatchup = Math.max(0, finite(maxCatchupSeconds, 30));
  const resumeGap = Math.max(0, finite(resumeGapSeconds, 5));
  if (elapsed > resumeGap) {
    return {
      simulateSeconds: 0,
      droppedSeconds: elapsed,
      resetClock: true,
    };
  }
  return {
    simulateSeconds: Math.min(maxCatchup, elapsed),
    droppedSeconds: Math.max(0, elapsed - maxCatchup),
    resetClock: false,
  };
}

/** Keep a transient notification bounded while it is being updated repeatedly. */
export function transientDeadline(now, currentDeadline, durationMs) {
  const current = finite(currentDeadline, 0);
  const at = finite(now, 0);
  const duration = Math.max(0, finite(durationMs, 0));
  return current > at ? current : at + duration;
}
